import adminApi from '../utils/adminRequest';

const toFormData = (obj = {}) => {
  const fd = new FormData();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (v instanceof File || v instanceof Blob) {
      fd.append(k, v);
      return;
    }
    fd.append(k, String(v));
  });
  return fd;
};

class AdminResumeTemplatesApi {
  list(params = {}) {
    return adminApi.get('/api/v1/admin/resume-templates', { params });
  }

  getDetail(id) {
    return adminApi.get(`/api/v1/admin/resume-templates/${id}`);
  }

  delete(id) {
    return adminApi.delete(`/api/v1/admin/resume-templates/${id}`);
  }

  create(payload) {
    const fd = payload instanceof FormData ? payload : toFormData(payload);
    return adminApi.post('/api/v1/admin/resume-templates', fd);
  }

  update(id, payload) {
    const fd = payload instanceof FormData ? payload : toFormData(payload);
    return adminApi.put(`/api/v1/admin/resume-templates/${id}`, fd);
  }

  uploadFile(id, file) {
    const fd = new FormData();
    fd.append('file', file);
    return adminApi.post(`/api/v1/admin/resume-templates/${id}/upload-file`, fd);
  }

  uploadPreviews(id, files) {
    const fd = new FormData();
    for (const f of files) fd.append('files', f);
    return adminApi.post(`/api/v1/admin/resume-templates/${id}/upload-previews`, fd);
  }

  setCover(id, coverPageNo) {
    const fd = new FormData();
    fd.append('cover_page_no', String(coverPageNo));
    return adminApi.put(`/api/v1/admin/resume-templates/${id}/cover`, fd);
  }

  reorder(id, pageNosCsv) {
    const fd = new FormData();
    fd.append('page_nos', pageNosCsv);
    return adminApi.put(`/api/v1/admin/resume-templates/${id}/previews/reorder`, fd);
  }
}

export default new AdminResumeTemplatesApi();
